import axios from 'axios';
import { SAVE_LOAD_FUNCTIONS_BASE_URL } from '../config/api';

/**
 * Fetch the token threshold for a specific user.
 * @param {string} userId - The user ID to fetch the token threshold for.
 * @returns {Promise<number>} - Resolves with the token threshold.
 */
const fetchTokenThreshold = async (userId) => {
  if (!userId) {
    console.error('User ID is required to fetch the token threshold.');
    return 250000; // Default value if no userId is provided
  }

  try {
    const response = await axios.post(`${SAVE_LOAD_FUNCTIONS_BASE_URL}/api/saveLoadFunctionAppHttp`, {
      action: 'gettokenthreshold',
      tablePartition: 'userResume',
      userID: userId,
      tableName: 'userProfiles',
    });

    return response.data.tokenThreshold || 2500000; // Default to 1,000,000 if not provided
  } catch (error) {
    console.error('Failed to fetch token threshold:', error);
    return 250000; // Return default threshold in case of error
  }
};

export default fetchTokenThreshold;
